import React from "react";

import { Box, CircularProgress, Grid, Stack, Typography } from "@mui/material";

export interface PlayerCardStatusProps {
    mode: "status" | "progress";
    statusIcon?: React.ReactNode;
    statusMessage?: string;
}

export function PlayerCardStatus(props: PlayerCardStatusProps) {
    return (
        <Grid
            container
            spacing={2}
            height="100%"
        >
            <Grid
                size={{
                    xs: 12,
                }}
                display="flex"
                justifyContent="center"
                alignItems="center"
            >
                <Stack alignItems="center">
                    {props.mode === "progress" && (
                        <CircularProgress size={105} />
                    )}

                    {props.mode === "status" && (
                        <Box
                            display="flex"
                            justifyContent="center"
                        >
                            {props.statusIcon}
                        </Box>
                    )}

                    {props.statusMessage && (
                        <Typography sx={{ textAlign: "center" }}>
                            {props.statusMessage}
                        </Typography>
                    )}
                </Stack>
            </Grid>
        </Grid>
    );
}
